import React from "react";
import { ColumnDef } from "@tanstack/react-table";
import { IApplicationSearchItem } from "models/Application.model";
import { useTranslation } from "react-i18next";
import AccessRequestActionButton from "../../AccessRequestTable/AccessRequestActionButton";

type Args = {
  onClickOpenApplication: (applicationId: number) => void;
  onClickRequestAccess: (applicationId: number) => void;
};

export const useApplicationSearchColumns = (args: Args) => {
  const { onClickOpenApplication, onClickRequestAccess } = args;
  const { t } = useTranslation();

  const applicationSearchColumns: ColumnDef<IApplicationSearchItem, any>[] = React.useMemo(
    () => [
      {
        id: "applicationNumber",
        header: t("Project ID"),
        enableSorting: false,
        accessorFn: (originalRow) => originalRow.consentNumber || originalRow.applicationNumber,
      },
      {
        accessorKey: "formDisplayName",
        header: t("Project"),
        enableSorting: false,
      },
      {
        accessorKey: "address",
        header: t("Address"),
        enableSorting: false,
      },
      {
        accessorKey: "authorityDisplayName",
        header: t("Authority"),
        enableSorting: false,
      },
      {
        accessorKey: "status",
        header: t("Status"),
        enableSorting: false,
      },
      {
        header: t("Action"),
        cell: (props) => (
          <AccessRequestActionButton
            applicationId={props.row.original.applicationId}
            accessRequestedDate={props.row.original.accessRequestedDate}
            hasApplicationAccess={Boolean(props.row.original.accessLevel)}
            applicationStatus={props.row.original.status}
            onClickOpenApplication={onClickOpenApplication}
            onClickRequestAccess={onClickRequestAccess}
          />
        ),
        enableSorting: false,
      },
    ],
    [t, onClickOpenApplication, onClickRequestAccess]
  );

  return applicationSearchColumns;
};
